import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VLayout,{attrs:{"align-center":"","justify-center":""}},[(_vm.rowData.lame_duck)?_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('a',_vm._g({},on),[_c(VIcon,{staticClass:"mx-2",attrs:{"color":"#EECB23","size":"18"}},[_vm._v("fa-solid fa-duck")])],1)]}}],null,false,119535555)},[_c('span',[_vm._v("Lame Duck")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }